import { useState, useCallback } from 'react';
import axios from 'axios';

export const useFeed = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch match stats
  const fetchMatchStats = useCallback(async (matchIds) => {
    setLoading(true);
    setError(null);
    try {
      const requests = matchIds.map((matchId) =>
        axios.get(
          `${process.env.REACT_APP_FEED_BASE_URL}/hockey/matches/${matchId}`
        )
      );

      const responses = await Promise.all(requests);
      const combinedMatchStats = responses.map(
        (response) => response.data.match
      );
      return combinedMatchStats.flat();
    } catch (err) {
      setError(err.message || 'Failed to fetch match stats');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch single match
  const fetchMatch = useCallback(async (matchId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_FEED_BASE_URL}/hockey/matches/${matchId}`
      );
      return response.data.match;
    } catch (err) {
      setError(err.message || 'Failed to fetch match');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchMatchStats,
    fetchMatch,
  };
};
